<!-- Wrapper -->
<div class="flex w-full min-w-0 flex-auto flex-col" *transloco="let t">
  <!-- Header -->
  <div class="bg-card relative z-49 flex h-16 w-full flex-0 items-center px-4 shadow dark:border-b dark:bg-transparent dark:shadow-none print:hidden sm:h-20 md:px-6">
    <!-- Logo -->
    <a [routerLink]="['/home']">
      <div class="mx-2 flex items-center lg:mr-8">
        <div class="hidden lg:flex">
          <img class="w-32 dark:hidden" src="assets/images/logo/accelup-logo-hires.webp" alt="Logo" />
          <img class="hidden w-32 dark:flex" src="assets/images/logo/accelup-logo-hires.webp" alt="Logo" />
        </div>
        <img class="flex w-32 lg:hidden" src="assets/images/logo/accelup-logo-hires.webp" alt="Logo" />
      </div>
    </a>
    <!-- Horizontal navigation (desktop) -->
    @if (!isScreenSmall && navigation?.horizontal) {
      <app-horizontal-nav class="mr-2" [name]="'mainNavigation'" [navigation]="navigation.horizontal"></app-horizontal-nav>
    }
    <!-- Mobile menu button -->
    @if (isScreenSmall && navigation?.default) {
      <button mat-icon-button [matMenuTriggerFor]="mobileMenu" class="ml-2">
        <mat-icon svgIcon="heroicons_outline:bars-3"></mat-icon>
      </button>
      <mat-menu #mobileMenu="matMenu" class="app-mobile-nav-menu">
        @for (item of navigation.default; track item.id || $index) {
          @if (item.type === 'basic' && item.link) {
            <a mat-menu-item [routerLink]="item.link" [routerLinkActive]="'active'">
              @if (item.icon) {
                <mat-icon matMenuItemIcon [svgIcon]="item.icon"></mat-icon>
              }
              <span>{{ item.title }}</span>
            </a>
          }
        }
      </mat-menu>
    }
    <div class="ml-auto flex items-center space-x-0.5 pl-2 sm:space-x-2"></div>
    <user></user>
  </div>

  <!-- Content -->
  <div class="min-h-5/6 flex w-full flex-auto flex-col">
    @if (true) {
      <router-outlet></router-outlet>
    }
  </div>

  <!-- Footer -->
  <div class="z-49 grid h-auto w-full grid-cols-3 gap-2 bg-white px-6 pt-6 dark:bg-transparent print:hidden">
    <div class="col-span-3 flex flex-row items-center gap-2 md:col-span-1 md:ml-6">
      <img class="h-14 w-18 rounded-md" src="assets/images/logo/eu_emblem.png" alt="EU" />
      <p class="test-justify text-secondary font-medium">{{ t('footer.eu-text') }}</p>
    </div>
    <div class="col-span-3 flex flex-col flex-nowrap justify-self-center p-4 md:col-span-1 md:p-0">
      <a class="self-center text-xl font-bold md:self-auto">{{ t('footer.about') }}</a>
      <div class="grid w-full grid-cols-2 pt-2">
        <a [routerLink]="['/faq']">{{ t('footer.faq') }}</a>
        <a [routerLink]="['/terms-and-conditions']">{{ t('footer.terms-and-conditions') }}</a>
        <a [routerLink]="['/about-us']">{{ t('footer.about-us') }}</a>
        <a [routerLink]="['/privacy-policy']">{{ t('footer.privacy-policy') }}</a>
        <a [routerLink]="['/how-it-works']">{{ t('footer.how-it-works') }}</a>
      </div>
    </div>
    <div class="col-span-3 flex flex-col flex-nowrap justify-self-center md:col-span-1 md:mr-6 md:justify-self-end">
      <a class="self-center pb-2 text-xl font-bold md:self-auto">{{ t('footer.contact') }}</a>
      <div class="flex flex-row gap-2 pt-2">
        <a class="flex items-center" href="https://twitter.com/AccelUP_ENoLL"><mat-icon svgIcon="feather:twitter"></mat-icon></a>
        <a class="flex items-center" href="https://www.facebook.com/accelupbyenoll"><mat-icon svgIcon="feather:facebook"></mat-icon></a>
        <a class="flex items-center" href="https://www.linkedin.com/company/accelup-by-enoll"><mat-icon svgIcon="feather:linkedin"></mat-icon></a>
        <a class="flex items-center" [routerLink]="['/contact']"><mat-icon svgIcon="feather:message-circle" class="text-indigo-600!"></mat-icon></a>
      </div>
    </div>
  </div>
  <div class="z-49 w-full bg-white px-2 py-2 text-lg dark:bg-transparent print:hidden md:py-0">
    {{ t('footer.copyright-information') }}
  </div>
</div>
